// src/services/lead.service.ts
import api from './api';

export interface Lead {
  id: string;
  VehicleID: string;
  SellerID: string;
  BuyerName: string;
  BuyerPhone: string;
  BuyerEmail?: string;
  Message?: string;
  LeadSource: string;
  Status: string;
  Notes?: string;
  CreatedAt: string;
  UpdatedAt: string;
  Vehicle?: {
    id: string;
    Title: string;
    Price: number;
  };
  Seller?: {
    id: string;
    FirstName: string;
    LastName: string;
    CompanyName: string;
  };
}

export const getLeads = async (params?: {
  status?: string;
  search?: string;
  page?: number;
  pageSize?: number;
}) => {
  const response = await api.get('/leads', { params });
  return response.data;
};

export const createLead = async (data: {
  vehicleId: string;
  buyerName: string;
  buyerPhone: string;
  buyerEmail?: string;
  message?: string;
  leadSource: string;
}) => {
  const response = await api.post('/leads', data);
  return response.data;
};

export const updateLeadStatus = async (id: string, status: string, notes?: string) => {
  const response = await api.patch(`/leads/${id}`, { status, notes });
  return response.data;
};

export const getLeadCounts = async () => {
  const response = await api.get('/leads/counts');
  return response.data;
};